















































import { Validator } from 'vee-validate'
import Vue from 'vue'
import { Component, Inject, Prop } from 'vue-property-decorator'

@Component({
  model: {
    prop: 'checked', // v-bind:checked
    event: 'input', // v-on:input
  },
})
export default class Radio extends Vue {
  @Inject()
  $validator: Validator

  @Prop()
  value

  @Prop()
  checked

  @Prop()
  id

  @Prop()
  label: string

  @Prop({ required: true })
  name: string

  @Prop({ default: false })
  disabled: boolean

  /*
   * Whether or not  the field has validation dependencies on other fields.
   * If this flag is set, some own logic on validation will be expected.
   */
  @Prop()
  hasDependencies: boolean

  updateValue () {
    this.$emit('input', this.value)
    this.$emit('checked', this.value)
  }

  labelClick() {
    this.$emit('label-click', this.value)
  }

  hasError(): boolean {
    if (this.hasDependencies) {
      return this.$validator.errors.has(this.name) && this.isTouched(this.name)
    }

    return this.$validator.errors.has(this.name)
  }

  getErrorMessage(): string {
    return this.$validator.errors.first(this.name)
  }

  style() {
    return {
      'c-input': true,
      'form-control': true,
      'form-control-sm': true,
      'is-invalid': this.hasError(),
    }
  }

  private isTouched(name: string): boolean {
    const field = this.$validator.fields.find({ name })

    if (!field) {
      return true
    }

    return field.flags.touched
  }

}
